import { useLocation, useParams } from "react-router-dom";

const PAGE_MAP = [
  ["/flight-schedule",   "flightSchedule"],
  ["/flight-operations", "flightOperations"],
  ["/crew-members",      "crewMembers"],
  ["/crew-schedule",     "crewSchedule"],
  ["/crew-payroll",      "crewPayroll"],
  ["/crew-kpis",         "crewKPIs"],
  ["/roster",            "rosterDetails"],
  ["/timesheets",        "timesheets"],
  ["/annual-leaves",     "annualLeaves"],
  ["/tasks",             "tasks"],
  ["/shifts",            "shifts"],
  ["/assignments",       "assignments"],
  ["/crewrequests",      "crewrequests"],
  ["/payroll",           "payroll"],
];

const useAIContext = () => {
  const { pathname } = useLocation();
  const params = useParams();

  const matched = PAGE_MAP.find(([path]) => pathname.startsWith(path));
  const page = matched ? matched[1] : "general";

  return {
    page,
    entityId: params.id || null,
    timestamp: new Date().toISOString(),
  };
};

export default useAIContext;
